import { Component } from '@angular/core';

@Component({
  selector: 'uex-dropdown-divider',
  template: '<div class="uex-dropdown-divider dropdown-divider"></div>'
})
export class DropdownDividerComponent { }
